import Breadcrumbs from '@components/shared/miscellaneous/breadcrumbs/breadcrumbs';
import style from './authors-page.module.scss';
import authorsImage from '/public/authors-images/authors-image.png'
import Image from 'next/image';
import Link from 'next/link';
import { Key, useEffect } from 'react';
import { IAuthor } from '@models/author.interface';


const AuthorsPage = (props: any) => {

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
        });
    };

    useEffect(() => {
        document.documentElement.style.scrollBehavior = "auto";
        return () => {
            document.documentElement.removeAttribute("style");
        };
    }, []);

    return (
        <>
            <div className={style.container} >
                <div className={style.authors_header}>
                    <Breadcrumbs lastElementTitle={props.author} />
                    <div className={style.authors_header_wrapper}>
                        <div className={style.authors_header_wrapper_info}>
                            <h1 className={style.authors_header_wrapper_info_title}>Meet our authors</h1>
                            <div className={style.authors_header_wrapper_info_discription}>Meet our team of invigorated authors, consisting of highly remarkable professionals in their respective fields. They are involved in developing content enabling every reader to achieve their desired objectives.</div>
                        </div>
                        <div className={style.authors_header_wrapper_image}>
                            <Image sizes="1024px" layout={'fill'} alt="arrow-icon" src={authorsImage} />
                        </div>
                    </div>
                </div>
                <div className={style.authors__container}>
                    {props.authors.map((author:IAuthor, index: Key) => (
                        <Link scroll={false} href={`/blog/authors/${author.slug}`} key={index}>
                            <a onClick={scrollToTop}>
                                <div key={index} className={style.author_card}>
                                    <div className={style.author_image}>
                                        {author.avatarUrl ? (
                                            <Image sizes="1024px" layout="fill" alt="arrow-icon" src={author.avatarUrl} />
                                        ) : (
                                            <span>No avatar available</span>
                                        )}
                                    </div>
                                    <h2 className={style.authors_name}>
                                        {author.name}
                                    </h2>
                                    <div className={style.author_about}>
                                        {author.aboutAuthor}
                                    </div>
                                    <div className={style.author_position}>
                                        {author.position}
                                    </div>
                                </div>
                            </a>
                        </Link>
                    ))}
                </div>
            </div>

        </>
    )
}

export default AuthorsPage;
